import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ThumbnailBig, FooterSection } from '@components'
import './KodeEtikCorporateGovernance.scss'
import { CorporateGovernanceAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import MyMenu from '../MyMenu'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CorporateGovernanceContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const KodeEtikCorporateGovernance = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async function () {
    setisLoading(true)
    const { data } = await CorporateGovernanceAPI('kode-etik')
    setdata(data.data)
    setisLoading(false)
  }

  return (
    <div>
      <TitleComponent title={data.judulBanneKodeEtik} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBanneKodeEtik}
            desc={isLoading ? '' : data.deskripsiBannerKodeEtik}
            img={isLoading ? '' : data.imageBannerDesktopKodeEtik}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBanneKodeEtik}
            desc={isLoading ? '' : data.deskripsiBannerKodeEtik}
            img={isLoading ? '' : data.imageBannerMobileKodeEtik}
          />
        </Mobile>
      </Container>

      <CorporateGovernanceContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            <p dangerouslySetInnerHTML={{ __html: data.deskripsiKodeEtik }}></p>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={4} />
          </div>
        </div>
      </CorporateGovernanceContainer>
      <FooterSection currentPage={t('kode_etik')} />
    </div>
  )
}

export default KodeEtikCorporateGovernance
